/*(function ($) {
    $('.two-columns-heading-animated .column-1, .two-columns-heading-animated .column-2').on('mouseenter', function () {
        $(this).find('.accordion-button').trigger('click');
        var parentClass = $(this).attr('parent-hover-class');
        $(this).parent().addClass(parentClass);
    });
    $('.two-columns-heading-animated .column-1, .two-columns-heading-animated .column-2').on('mouseleave', function () {
        $(this).find('.accordion-button').trigger('click');
        var parentClass = $(this).attr('parent-hover-class');
        $(this).parent().removeClass(parentClass);
    });
})(jQuery);*/

(() => {
    const elts = {
        col1text1: document.getElementById('col1text1'),
        col1text2: document.getElementById('col1text2'),
        col2text1: document.getElementById('col2text1'),
        col2text2: document.getElementById('col2text2'),
    };

    var texts1 = [];
    if (typeof column1Texts !== 'undefined') {
        texts1 = column1Texts;
    }
    var texts2 = [];
    if (typeof column2Texts !== 'undefined') {
        texts2 = column2Texts;
    }

    const morphTime = 1;
    const cooldownTime = 0.25;

    let textIndex = texts1.length - 1;
    let time = new Date();
    let morph = 0;
    let cooldown = cooldownTime;

    if (texts1.length > 0 && texts2.length > 0) {
        elts.col1text1.textContent = texts1[textIndex % texts1.length];
        elts.col1text2.textContent = texts1[(textIndex + 1) % texts1.length];

        elts.col2text1.textContent = texts2[textIndex % texts2.length];
        elts.col2text2.textContent = texts2[(textIndex + 1) % texts2.length];
    }

    function doMorph() {
        morph -= cooldown;
        cooldown = 0;

        let fraction = morph / morphTime;

        if (fraction > 1) {
            cooldown = cooldownTime;
            fraction = 1;
        }

        setMorph(fraction);
    }

    function setMorph(fraction) {
        elts.col1text2.style.filter = `blur(${Math.min(8 / fraction - 8, 100)}px)`;
        elts.col1text2.style.opacity = `${Math.pow(fraction, 0.4) * 100}%`;

        elts.col2text2.style.filter = `blur(${Math.min(8 / fraction - 8, 100)}px)`;
        elts.col2text2.style.opacity = `${Math.pow(fraction, 0.4) * 100}%`;

        fraction = 1 - fraction;
        elts.col1text1.style.filter = `blur(${Math.min(8 / fraction - 8, 100)}px)`;
        elts.col1text1.style.opacity = `${Math.pow(fraction, 0.4) * 100}%`;

        elts.col2text1.style.filter = `blur(${Math.min(8 / fraction - 8, 100)}px)`;
        elts.col2text1.style.opacity = `${Math.pow(fraction, 0.4) * 100}%`;

        elts.col1text1.textContent = texts1[textIndex % texts1.length];
        elts.col1text2.textContent = texts1[(textIndex + 1) % texts1.length];

        elts.col2text1.textContent = texts2[textIndex % texts2.length];
        elts.col2text2.textContent = texts2[(textIndex + 1) % texts2.length];
    }

    function doCooldown() {
        morph = 0;

        elts.col1text2.style.filter = '';
        elts.col1text2.style.opacity = '100%';

        elts.col1text1.style.filter = '';
        elts.col1text1.style.opacity = '0%';

        elts.col2text2.style.filter = '';
        elts.col2text2.style.opacity = '100%';

        elts.col2text1.style.filter = '';
        elts.col2text1.style.opacity = '0%';
    }

    function animate() {
        requestAnimationFrame(animate);

        let newTime = new Date();
        let shouldIncrementIndex = cooldown > 0;
        let dt = (newTime - time) / 1000;
        time = newTime;

        cooldown -= dt;

        if (cooldown <= 0) {
            if (shouldIncrementIndex) {
                textIndex++;
            }

            doMorph();
        } else {
            doCooldown();
        }
    }

    if (texts1.length > 0 && texts2.length > 0) {
        animate();
    }
})();
